import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import 'semantic-ui-css/components/dropdown.min.css'
import 'semantic-ui-css/components/transition.min.css'

const SearchableDropdown = ({
    options,
    handleOnChange,
    onClick,
    placeholderText,
    disabled = false,
}) => (
    <Dropdown
        placeholder={placeholderText}
        fluid
        search
        selection
        selectOnBlur={false}
        selectOnNavigation={false}
        options={options}
        onChange={handleOnChange}
        disabled={disabled}
        onClick={onClick}
        value={options.find((x) => x.selected)?.value}
    />
)

export default SearchableDropdown
